import { getI18n } from 'react-i18next';

import { ColumnConfiguration } from 'src/common/components/ConfigurableTable/models/configurableTable';

const i18n = getI18n();

export const PRODUCT_RSIM_TABLE_CONFIGURATION: ColumnConfiguration[] = [
  {
    field: 'euicc',
    headerName: i18n.t('common.eid'),
    resizable: false,
    sortable: true,
    pinnable: false,
    minWidth: 280,
  },
  {
    field: 'subscriptionStatus',
    headerName: i18n.t('rSimInventory.subscriptionStatus'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 150,
  },
  {
    field: 'rSimStatus',
    headerName: i18n.t('rSimInventory.rsimStatus'),
    resizable: false,
    sortable: false,
    pinnable: false,
  },
  {
    field: 'lastPollingTimestamp',
    headerName: i18n.t('rSimInventory.lastPollingTimestamp'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 168,
  },
  {
    field: 'productCode',
    headerName: i18n.t('products.common.productCode'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 168,
  },
  {
    field: 'dataUsage',
    headerName: i18n.t('common.data'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 156,
  },
  {
    field: 'outMinuteUsage',
    headerName: i18n.t('common.outMinuteUsageProduct'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 156,
    subField: {
      field: 'inMinuteUsage',
      headerName: i18n.t('common.inMinuteUsageProduct'),
    },
  },
  {
    field: 'outTextUsage',
    headerName: i18n.t('common.smsMO'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 156,
    subField: {
      field: 'inTextUsage',
      headerName: i18n.t('common.smsMT'),
    },
  },
  {
    field: 'appliedOtaConfigurationProfile',
    headerName: i18n.t('rSimInventory.configuration'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 240,
    subField: {
      field: 'appliedOtaConfigurationVersion',
      headerName: i18n.t('rSimInventory.version'),
    },
  },
  {
    field: 'accountName',
    headerName: i18n.t('common.accountName'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 300,
    subField: {
      field: 'accountNumber',
      headerName: i18n.t('common.accountNumber'),
    },
  },
  {
    field: 'installerName',
    headerName: i18n.t('simInventory.organisationName'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 272,
    subField: {
      field: 'installerRef',
      headerName: i18n.t('simInventory.organisationNumber'),
      sortable: true,
    },
  },
  {
    field: 'orderNumber',
    headerName: i18n.t('rSimInventory.orderNumber'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 148,
    subField: {
      field: 'customerReference',
      headerName: i18n.t('rSimInventory.orderReference'),
    },
  },
  {
    field: 'connectionId',
    headerName: i18n.t('rSimInventory.connectionId'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 148,
  },
  {
    field: 'tags',
    headerName: i18n.t('common.tag'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 150,
  },
];
